<template>
    <panel title="Zöld lakat">
        <Loading title="Zöld lakat lekérése" v-if="green_lock === false"></Loading>
        <div class="text-center" v-else>
            <span class="fa-stack fa-8x" v-if="!green_lock" @click="openSet()">
                <i class="fa-solid fa-lock fa-stack-2x text-green"></i>
                <i class="fa-solid fa-stack-1x text-white fs-5 mt-30px font-monospace"><i class="fa fa-plus"></i> Lakat
                    kiadás</i>
            </span>
            <span class="fa-stack fa-8x" v-else v-b-modal.deleteModal>
                <i class="fa-solid fa-lock fa-stack-2x text-green"></i>
                <i class="fa-solid fa-stack-1x text-white fs-4 mt-30px font-monospace"><i class="fa fa-arrow-rotate-left"></i> #{{ green_lock.lock_number }}</i>
            </span>
            <b-modal id="setModal">
                <template slot="modal-header">
                    <h4 class="modal-title">Zöld lakat kiadás</h4>
                    <a class="btn-close" @click="closeSetModal()"></a>
                </template>
                <Loading title="Zöld lakat hozzáadása" v-if="loading"></Loading>
                <div v-else>
                    <label class="form-label">Lakatszám:</label>
                    <input type="number" class="form-control" v-model="form.lock_number">
                    <div class="invalid-feedback d-block" v-if="errors.lock_number">
                        {{ errors.lock_number[0] }}
                    </div>
                </div>
                <template #modal-footer="{ cancel }">
                    <b-button variant="default" @click="cancel()">
                        Mégse
                    </b-button>
                    <PinSignatureSimple v-if="user" :user_id="user.id" @signed="setLock" :hideSignButton="!user.pin_set"
                        ref="pin_signature_1"></PinSignatureSimple>
                </template>
            </b-modal>
            <b-modal id="deleteModal">
                <template slot="modal-header">
                    <h4 class="modal-title">Zöld lakat visszaadás</h4>
                    <a class="btn-close" @click="closeDeleteModal()"></a>
                </template>
                <Loading title="Zöld lakat visszahozása" v-if="loading"></Loading>
                <div v-else class="text-center">
                    <h3>Hitelesítse <!--pinkóddal--></h3> 
                    <h2>a #{{ green_lock.lock_number }}</h2>
                    <h5>számú lakat visszahozását!</h5> 
                </div>
                <template #modal-footer="{ cancel }">
                    <b-button variant="default" @click="cancel()">
                        Mégse
                    </b-button>
                   <PinSignatureSimple v-if="user" :user_id="user.id" @signed="returnLock" :hideSignButton="!user.pin_set"
                        ref="pin_signature_2"></PinSignatureSimple>
                </template>
            </b-modal>
        </div>
    </panel>
</template>

<script>
import Loading from "@/components/Loading";
import PinSignatureSimple from "@/components/PinSignatureSimple";
import GreenLock from "@/apis/GreenLock";
export default {
    props: { user: Object },
    components: { Loading, PinSignatureSimple },
    data() {
        return {
            green_lock: false,
            form: {
                user_id: this.user.id,
                lock_number: null,
            },
            loading: false,
            errors: [],
        }
    },
    created() {
        GreenLock.getLock(this.user.id).then(response => {
            this.green_lock = response.data;
        });
    },
    methods: {
        openSet(){
            this.form.lock_number = null;
            this.$bvModal.show('setModal');
        },
        setLock() {
            this.loading = true;
            GreenLock.setLock(this.form).then(response => {
                this.green_lock = response.data;
                this.closeSetModal();
            }).catch(error => {
                this.$refs.pin_signature_1.resetStatus();
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        returnLock(){
            this.loading = true;
            GreenLock.returnLock(this.green_lock.id).then(() => {
                this.green_lock = "";
                this.closeDeleteModal();
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        closeSetModal() {
            this.$refs.pin_signature_1.resetStatus();
            this.form.lock_number = null;
            this.$bvModal.hide('setModal');
        },
        closeDeleteModal() {
            this.$refs.pin_signature_2.resetStatus();
            this.$bvModal.hide('deleteModal');
        }
    }
}
</script>